module.exports = __webpack_public_path__ + "static/media/buildings.0899ed1c.svg";